import { DynamicFormElement } from "../../../FormBuilder/FormBuilder.types";

export const secondFormElements: DynamicFormElement[] = [
  {
    type: "ImagePicker",
    name: "screenshot",
  },
];
